import './App.css';
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Signup from './Components/Auth/Signup';
import Overview from './Components/Main/Overview';
import Home from './Components/Main/Home';
import Transactions from './Components/Main/Transactions';
import QATicket from './Components/Main/QATicket';
import Settings from './Components/Main/Settings';
import Payment from './Components/Main/Payment';
import Invoice from './Components/Main/invoice';
import Website from './Components/Main/Websites';
import Publishers from './Components/Main/Publishers';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './Components/Auth/AuthContext';
import Analytics from './Components/Main/Analytics';
import Adunits from './Components/Main/Adunits';
import AdsTxtConfiguration from './Components/Main/AdsTxtConfiguration';
import AdsCodeConfiguration from './Components/Main/AdsCodeConfiguration';
import AdminSettings from './Components/Main/AdminSettings';
import Notes from './Components/Main/Notes';
import PaymentDetails from './Components/Payment/PaymentDetails';
import Adscode from './Components/Main/Adscode';
import Layout from './layout/Layout';
import { showVersionUpdateToast } from './Components/Animations/VersionUpdateToast';
import Dashboard from './Components/Main/Dashboard';
import UpdateToast from './Components/Common/UpdateToast';

const CURRENT_VERSION = "1.0.2";

function App() {
  const [showUpdateToast, setShowUpdateToast] = useState(false);
  const [isCheckingVersion, setIsCheckingVersion] = useState(true);

  useEffect(() => {
    checkForUpdates();
    checkVersion();
    blockDevTools();
  }, []);

  /** --------------------
   * VERSION CHECK LOGIC
   * -------------------- */
  const checkForUpdates = () => {
    const latestVersion = localStorage.getItem("latestVersion");
    const releaseNotes =
      localStorage.getItem("releaseNotes") ||
      "✨ New features: Dark mode, improved analytics dashboard, and bug fixes.";

    if (latestVersion && isNewerVersion(latestVersion, CURRENT_VERSION)) {
      const dismissedVersion = localStorage.getItem("dismissedVersion");
      if (dismissedVersion !== latestVersion) {
        showVersionUpdateToast(latestVersion, releaseNotes);
      }
    }
  };

  const isNewerVersion = (latest, current) => {
    const latestParts = latest.split(".").map(Number);
    const currentParts = current.split(".").map(Number);

    for (let i = 0; i < latestParts.length; i++) {
      if ((latestParts[i] || 0) > (currentParts[i] || 0)) return true;
      if ((latestParts[i] || 0) < (currentParts[i] || 0)) return false;
    }
    return false;
  };

  const checkVersion = () => {
    const storedVersion = localStorage.getItem("appVersion");
    if (!storedVersion) {
      localStorage.setItem("appVersion", CURRENT_VERSION);
      setIsCheckingVersion(false);
      return;
    }
    if (storedVersion !== CURRENT_VERSION) {
      setShowUpdateToast(true);
    }
    setIsCheckingVersion(false);
  };

  const handleRefresh = () => {
    localStorage.setItem("appVersion", CURRENT_VERSION);
    window.location.reload(true);
  };

  const handleDismiss = () => {
    localStorage.setItem("appVersion", CURRENT_VERSION);
    setShowUpdateToast(false);
  };

  /** --------------------
   * DEVTOOLS BLOCK LOGIC
   * -------------------- */
  const blockDevTools = () => {
    // Disable right-click
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable common DevTools shortcuts
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") ||
        (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") ||
        (e.ctrlKey && e.key.toLowerCase() === "u")
      ) {
        e.preventDefault();
      }
    });

    // Detect if DevTools is open
    const devToolsDetector = setInterval(() => {
      const threshold = 160;
      const start = performance.now();
      debugger; // triggers delay if DevTools is open
      const end = performance.now();
      if (end - start > threshold) {
        alert("DevTools is not allowed!");
        window.location.href = "about:blank"; // Kick user out
      }
    }, 1000);

    return () => clearInterval(devToolsDetector);
  };

  /** --------------------
   * UI
   * -------------------- */


  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route element={<Layout />}>
            {/* Protected Routes */}
            <Route
              path="/overview"
              element={
                <ProtectedRoute >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adunits"
              element={
                <ProtectedRoute>
                  <Adunits />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <Transactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qa-tickets"
              element={
                <ProtectedRoute>
                  <QATicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <Payment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice"
              element={
                <ProtectedRoute>
                  <Invoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-info"
              element={
                <ProtectedRoute>
                  <PaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/website"
              element={
                <ProtectedRoute>
                  <Website />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdsTxtConfiguration"
              element={
                <ProtectedRoute>
                  <AdsTxtConfiguration />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdsCodeConfiguration"
              element={
                <ProtectedRoute>
                  <AdsCodeConfiguration />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adscode"
              element={
                <ProtectedRoute>
                  <Adscode />
                </ProtectedRoute>
              }
            />

            {/* Admin-Only Route */}
            <Route
              path="/publishers"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <Publishers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminsetting"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notes"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <Notes />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
      <UpdateToast
        isVisible={showUpdateToast}
        onDismiss={handleDismiss}
        onRefresh={handleRefresh}
      />
    </AuthProvider>
  );
}

export default App;
